import { ReactElement, FC, cloneElement } from 'react';
import classnames from 'classnames';

import { isIconComponent, IconDynamic } from '@hh.ru/magritte-ui-icon';

import styles from './styles.less';

interface CellItemProps {
    item: ReactElement;
    isRight?: boolean;
}

export const CellItem: FC<CellItemProps> = ({ item, isRight }) => {
    const defaultProps: Record<string, unknown> = {};
    if (isIconComponent(item)) {
        defaultProps.initial = item.props.initial || 'secondary';
        defaultProps.disabled = item.props?.disabled || 'secondary';

        return (
            <div
                className={classnames(styles.item, {
                    [styles.itemRight]: isRight,
                })}
            >
                <IconDynamic>{cloneElement(item, defaultProps)}</IconDynamic>
            </div>
        );
    }

    return (
        <div
            className={classnames(styles.item, {
                [styles.itemRight]: isRight,
            })}
        >
            {item}
        </div>
    );
};
